import { useParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../components/ui/tabs";
import RentalSchedules from "../rental-modules/RentalSchedules";
import NoticeOfAssignment from "../rental-modules/NoticeOfAssignment";
import Invoices from "../rental-modules/Invoices";
import { useEffect, useRef, useState } from "react";
import ViewSchedule from "../schedules/ViewSchedule";
import apiService from "../../services/apiService";
import { NoticeOfAssignment as NoAType } from "../../types/schema";
import ViewNoticeOfAssignment from "../noa/ViewNoticeOfAssignment";
import { fetchCustomerAddresses, toBillToAddress } from "../../lib/customer-addresses";

interface IndexProps {
  initialTab?: "schedules" | "noa" | "invoices" | "cashflow" | "ledger" | "revenue";
  scheduleKey?: number;
  scheduleData?: any;
}

interface TransformedAddress {
  id: string;
  label: string;
  address: string;
  gstin?: string;
  stateId?: string;
}

interface AdminUserList {
  id: number;
  name: string;
}

const SchedulePage = ({ initialTab,scheduleKey,scheduleData }: IndexProps) => {
  const { customerId } = useParams<{ customerId: string }>();
  const [customerAddress, setCustomerAddress] = useState<TransformedAddress[] | null>(null);
  const [tab, setTab] = useState<string>(initialTab || "");
  const heroRef = useRef<HTMLDivElement | null>(null);
  const [schedule, setSchedule] = useState<any | null>(scheduleData || null);
  const [adminUserList, setAdminUserList] = useState<AdminUserList[]>([]);
  const [noA, setNoA] = useState<NoAType | null>(null);
  const [tdsList, setTDSList] = useState<any[]>([]);

  useEffect(() => {
    if(scheduleKey && scheduleKey > 0) {
      setTab(initialTab || "");
    }
  }, [scheduleKey,initialTab]);

  const titles = {
    schedules: "Rental Schedules",
    noa: "Notice of Assignment",
    // invoices: "Invoices",
    ledger: "Customer Ledger",
    revenue: "Revenue MIS"
  };
  
  const descriptions = {
    schedules: "Manage schedules, assignments, invoices, and monitor cashflows with accurate tax and PV calculations.",
    noa: "Create and manage notice of assignments for your rental agreements.",
    // invoices: "Manage invoices, track payments, and generate reports with detailed GST calculations.",
    ledger: "View and manage customer ledger transactions, including payments, receipts, and balances.",
    revenue: "Track and analyze revenue data, including income, expenses, and profitability metrics.",
  };

  
interface ApiResponse<T> {
  data: T;
  message?: string;
  status?: number;
  schedules?:any[]
}


  const title = titles[tab as keyof typeof titles];
  const description = descriptions[tab as keyof typeof descriptions];

  // useEffect(() => {
  //   // Sync tab with route
  //   const path = location.pathname;
  //   if (path.startsWith("/noa")) setTab("noa");
  //   else if (path.startsWith("/invoices")) setTab("invoices");
  //   else if (path.startsWith("/cashflow")) setTab("cashflow");
  //   else if (path.startsWith("/ledger")) setTab("ledger");
  //   else if (path.startsWith("/revenue")) setTab("revenue");
  //   else setTab("schedules");
  // }, [location.pathname]);

  const handleViewSchedule = (schedule: any) => {
    setTab("schedules-view");
    setSchedule(schedule);
  };

  const handleViewNoA = (noa: NoAType) => {
    setTab("notice-of-assignment-view");
    setNoA(noa);
  };

  useEffect(() => {
    if (customerId) {
      getCustomerAddress(customerId);
    }
  }, [customerId]);

  useEffect(() => {
    fetchAdminUserList();
  }, []);


  const fetchAdminUserList = async () => {
    try {
      const response = await apiService.get<{ data: AdminUserList[] }>(
        `/customers/get-admin-user-list`
      );
      const transformedDocs = response.data.map((doc) => ({
        name: doc.name,
        id: doc.id,
      }));
      setAdminUserList(transformedDocs);
    } catch (error) {
      console.error("Error fetching admin users:", error);
    }
  };


  

  const getTDSList = async () => {
    const response = await apiService.get<ApiResponse<any>>(`/customers/get-tds-list`);
    setTDSList(response.data);
  };

  useEffect(() => {
    getTDSList();
  }, []);

  const getCustomerAddress = async (id: string) => {
    try {
      const list = await fetchCustomerAddresses(id);
      setCustomerAddress(list.map(toBillToAddress));
    } catch {
      setCustomerAddress([]);
    }
  };

  // const nav = useMemo(
  //   () => (
  //     <header className="sticky top-0 z-10 bg-background/80 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b">
  //       <div className="container mx-auto flex items-center justify-between py-4">
  //         <Link to="/" aria-label="Asset Leasing Platform Home" className="font-semibold tracking-tight">
  //           Asset Leasing Platform
  //         </Link>
  //         <nav className="hidden md:flex gap-2">
  //           <Link to="/schedules"><Button variant={tab === "schedules" ? "default" : "secondary"}>Rental Schedules</Button></Link>
  //           <Link to="/noa"><Button variant={tab === "noa" ? "default" : "secondary"}>Notice of Assignment</Button></Link>
  //           <Link to="/invoices"><Button variant={tab === "invoices" ? "default" : "secondary"}>Invoices</Button></Link>
  //           <Link to="/cashflow"><Button variant={tab === "cashflow" ? "default" : "secondary"}>Cashflow</Button></Link>
  //           <Link to="/ledger"><Button variant={tab === "ledger" ? "default" : "secondary"}>Ledger</Button></Link>
  //           <Link to="/revenue"><Button variant={tab === "revenue" ? "default" : "secondary"}>Revenue MIS</Button></Link>
  //         </nav>
  //       </div>
  //     </header>
  //   ),
  //   [tab]
  // );

  return (
    <div
      ref={heroRef}
      onMouseMove={(e) => {
        const x = (e.clientX - window.innerWidth / 2) * 0.02;
        const y = (e.clientY - window.innerHeight / 2) * 0.02;
        heroRef.current?.style.setProperty("--x", `${x}px`);
        heroRef.current?.style.setProperty("--y", `${y}px`);
      }}
      className="min-h-screen bg-background"
    >
      {/* {nav} */}
      <main className="mx-auto px-2 py-2">
      {title && (
  <section className="">
    <h1 className="text-3xl md:text-4xl font-semibold tracking-tight mb-2">
      {title}
    </h1>

    <p className="text-muted-foreground">
      {description}
    </p>
  </section>
)}
        <Tabs value={tab} onValueChange={(v:any) => setTab(v as any)}>
          <TabsList className="grid w-full grid-cols-6 md:hidden mb-4">
            <TabsTrigger value="schedules">Schedules</TabsTrigger>
            <TabsTrigger value="notice-of-assignment">NoA</TabsTrigger>
            <TabsTrigger value="invoices">Invoices</TabsTrigger>
          </TabsList>
          <TabsContent value="schedules"><RentalSchedules onViewSchedule={handleViewSchedule} tdsRateList={tdsList} /></TabsContent>
          {/* onViewSchedule={handleViewSchedule} */}
          <TabsContent value="schedules-view"><ViewSchedule adminUserList={adminUserList} customerAddresses={customerAddress} schedule={schedule ? schedule : null} tdsRateList={tdsList} onBack={() => setTab("schedules")} onAddressesChange={setCustomerAddress} /></TabsContent>
          <TabsContent value="notice-of-assignment"><NoticeOfAssignment handleViewNoA={handleViewNoA} /></TabsContent>
          <TabsContent value="notice-of-assignment-view"><ViewNoticeOfAssignment noa={noA ? noA : null} onBack={() => setTab("notice-of-assignment")} onNoAUpdated={setNoA} /></TabsContent>
          <TabsContent value="invoices"><Invoices customerId={customerId} /></TabsContent>

        </Tabs>
      </main>
    </div>
  );
};

export default SchedulePage;
